/**
 * Entry application component used to compose providers and render Routes.
 * */

import React, { Fragment, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
// import { I18nProvider } from "../_metronic/i18n";
import { LayoutSplashScreen } from "../_metronic/layout";
import { Routes } from "../app/Routes";
import API from "./helpers/devApi";
import { apsisDecrypt } from "./helpers/apsisEncryption";
import AuthInit from "./modules/Auth/redux/AuthInit";
import { actions } from "./modules/Auth/redux/authRedux";
import def from "../index.scss";
import cus from "../custom.scss";
import DynamicCSSLoader from "./helpers/DynamicCSSLoader";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import useLocalStorage from "use-local-storage";
import jwtDecode from "jwt-decode";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const secretPass = "XkhZG4fW2t2W";
// let landedSearchParams = new URLSearchParams(window.location.search);
// landedSearchParams.delete("user");
// window.landed_url =
//   window.location.pathname +
//   (landedSearchParams.toString() ? "?" + landedSearchParams.toString() : "");
export default function App({ store, basename, persistor }) {
  const [userJSON, setUserJSON] = useState();
  const dispatch = useDispatch();
  const handle = useFullScreenHandle();
  const defaultLight = window.matchMedia("(prefers-color-scheme: light)")
    .matches;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const user = params.get("user");

    if (user) {
      try {
        console.log(user);
        
        let decData = apsisDecrypt(user);
        setUserJSON(JSON.parse(decData));
        const authToken = JSON.parse(decData);
        dispatch(actions.login(authToken));
        const { access_token, refresh_token } = authToken;
        localStorage.setItem("CORE_MODULE_AUTH", access_token);
        const erpToken = {
          access_token: access_token,
          refresh_token: refresh_token,
        };

        const coreModuleInfo = jwtDecode(access_token);
        localStorage.setItem("user", JSON.stringify(coreModuleInfo));
        coreModuleInfo.token = access_token;
        dispatch(actions.coreModuleLogin(coreModuleInfo));

        localStorage.setItem("AUTH", JSON.stringify(erpToken));
        localStorage.setItem("fromErp", true);
        const path = window.location.pathname;
        if(user&&path.includes('global-view')){
          console.log(path);
          params.delete('user');
          let url = `${path}?${params.toString()}`
          window.redirect_to =  url;
        }

      } catch (error) {
        console.error("Failed to decrypt user parameter:", error.message);
        // Optionally show a toast notification to the user
        toast.error("Invalid authentication token. Please try again.");
      }
    }
  }, [dispatch]);

  return (
    <div data-theme={"light"}>
      <FullScreen handle={handle}>
        <React.Suspense fallback={<LayoutSplashScreen />}>
          {/* Override `basename` (e.g: `homepage` in `package.json`) */}
          <BrowserRouter basename={basename}>
            {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
            {/* Provide `react-intl` context synchronized with Redux state.  */}
            {/* <I18nProvider> */}
            {/* Render routes with provided `Layout`. */}
            <AuthInit>
              <Toaster />
              <ToastContainer
                position="bottom-right"
                closeOnClick={false}
                draggable
                hideProgressBar
                closeButton
              />
              <Routes handle={handle} />
            </AuthInit>
            {/* </I18nProvider> */}
          </BrowserRouter>
        </React.Suspense>
      </FullScreen>
    </div>
  );
}
